import { eAtlas, eMaterialAsset, Game } from "../../../Game";
import { ModelUtils } from "../../../Utils/Models/ModelUtils";
import { TextureAtlasFramePlaneData, AtlasUtils } from "../../../Utils/Atlas/AtlasUtils";
import { TIMER } from "../../Gameplay";
import { Stadium } from "../../Stadium/Stadium";
import { TargetBase } from "../Targets/Target";



export const enum eTrajDisMark {
    dot,
    cross
}



const enum eTrajDisState {
    hiden,
    visible,
    hiding,
}



export abstract class TrajectoryDisplayer {
    private static readonly DEF_OPACITY = 1;

    /**
     * (RO) Terc, pro ktery je trajektorie urcena
     */
    get target(): TargetBase { return TrajectoryDisplayer._target; }
    private static _target: TargetBase;
    /**
     * Data pro jednotlive znacky pouzivane pro vykresleni trajektorie
     */
    protected static _marks: TextureAtlasFramePlaneData[];
    /**
     * Mesh, ktery zobrazi trajektorii
     */
    protected static _mesh: pc.Mesh;
    /**
     * Model 
     */
    private static _model: pc.Model;
    /**
     * Entita
     */
    private static _entity: pc.Entity;
    /**
     * Aktualni stav
     */
    private static _state: eTrajDisState;
    /**
     * Cas zahajeni skryti
     */
    private static _stateTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        if (!TrajectoryDisplayer._mesh) {
            // Znacky
            let atlas = Game.getAtlas(eAtlas.def1);

            TrajectoryDisplayer._marks = [];
            TrajectoryDisplayer._marks[eTrajDisMark.dot] = new TextureAtlasFramePlaneData(atlas, "targets/trajectory/dot", 150);
            TrajectoryDisplayer._marks[eTrajDisMark.cross] = new TextureAtlasFramePlaneData(atlas, "targets/trajectory/cross", 150);

            // Mesh
            TrajectoryDisplayer._mesh = new pc.Mesh(Game.app.graphicsDevice);

            // Entita
            let e = TrajectoryDisplayer._entity = new pc.Entity();

            e.addComponent(pc.eCompomentType.model, {
                type: pc.eModelType.asset,
                castShadows: false,
                receiveShadows: false,
            });
            e.setLocalPosition(0, 0, Stadium.END_Z - 0.1);
            e.enabled = false;
            Game.app.root.addChild(e);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        TrajectoryDisplayer._entity.enabled = false;
        TrajectoryDisplayer._state = eTrajDisState.hiden;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (TrajectoryDisplayer._state == eTrajDisState.hiding) {
            let progress = (TIMER.time - TrajectoryDisplayer._stateTime) / 1000;

            if (progress < 1) {
                TrajectoryDisplayer._entity.model.meshInstances[0].setParameter("material_opacity", TrajectoryDisplayer.DEF_OPACITY - TrajectoryDisplayer.DEF_OPACITY * pc.SineOut(progress));
            }
            else {
                this.reset();
            }
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    abstract show(target: TargetBase): void;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected showEnd(target: TargetBase): void {
        TrajectoryDisplayer._target = target;

        if (!TrajectoryDisplayer._model) {
            TrajectoryDisplayer._model = ModelUtils.createModel([TrajectoryDisplayer._mesh], Game.app.assets.find(eMaterialAsset.atlasWithOpacity, pc.eAssetType.material).resource as pc.StandardMaterial);
            TrajectoryDisplayer._entity.model.model = TrajectoryDisplayer._model;
        }

        TrajectoryDisplayer._entity.model.meshInstances[0].setParameter("material_opacity", TrajectoryDisplayer.DEF_OPACITY);
        TrajectoryDisplayer._entity.enabled = true;
        TrajectoryDisplayer._state = eTrajDisState.visible;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    hide(): void {
        TrajectoryDisplayer._state = eTrajDisState.hiding;
        TrajectoryDisplayer._stateTime = TIMER.time;
    }
}